import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import Flex from 'components/Flex'
import { Checkbox } from 'antd'

export const FooterFlex = styled(Flex)`
  gap: 10px;
`

export const CheckBoxDiv = styled.div`
  padding: 10px 0 5px 6px;
`
export const HeaderFlex = styled(Flex)`
  gap: 15px;
  margin: 15px 0;
`
export const SearchDiv = styled.div`
  flex: 1;
`
export const InterviewerDiv = styled.div`
  margin: 10px 0;
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_20};
`
export const CollageNameFlex = styled(Flex)`
  flex-direction: column;
  gap: 5px;
  margin-left: 10px;
`
export const LocationAdd = styled(Flex)`
  flex-direction: column;
  align-self: center;
`
export const CollegeNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: 14px;
  color: ${COLORS.GREY_T_20};
`
export const LocationDiv = styled.div`
font-weight: ${FONT.FW_600};
  font-size: 14px;
  color: ${COLORS.GREY_T_20};
  display:flex
`
export const CollegeCity = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: 14px;
  color: ${COLORS.GREY_T_60};
`
export const CollageDetailsFlex = styled(Flex)`
  line-height: normal;
  width: 100%;
  align-items: center;
  padding: 10px 0 15px 0;
  border-bottom: ${props =>
    props?.idBoarder ? '' : `1px solid ${COLORS.GREY_T_90}`};
`
export const StatusSpan = styled.span`
  margin-left: 10px;
  padding: 4px 6px;
  width: 77px;
  height: 23px;
  background: #eff8f4;
  border: 1px solid #bee1d4;
  border-radius: 6px;
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: ${COLORS.GREEN_S_100};
`

export const CheckBoaxGroup = styled(Checkbox.Group)`
  width: 100%;
`
